<template>
    <div>
        <v-card elevation="2">
            <v-card-title>{{ `Cron ${t("Logs").toLowerCase()}` }}</v-card-title>
            <v-card-text>
                <v-overlay :value="loadingCronLogsList">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-data-table
                    :items-per-page="10"
                    :footer-props="footerProps"
                    class="cron-table"
                    dense
                    :options.sync="options"
                    :headers="cronTableHeaders"
                    :server-items-length="totalCronLogs"
                    :items="cronLogs"
                >
                    <template v-slot:item="{ item }">
                        <tr :key="'cron_' + item.id">
                            <td>{{ getTypeUppercase(item.type) }}</td>
                            <td>{{ item.date ? item.date : "-" }}</td>
                            <td>{{ item.new_rows ? item.new_rows : "-" }}</td>
                            <td>{{ item.rows_edited ? item.rows_edited : "-" }}</td>
                            <td>{{ item.error ? item.error : "-" }}</td>
                            <td>{{ item.file_name ? item.file_name : "-" }}</td>
                            <td style="text-align: end">
                                <span class="dot" :style="{ 'background-color': getStatusColor(item.status) }" />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-card elevation="2" class="mt-3">
            <v-card-title>{{ `Error ${t("Logs").toLowerCase()}` }}</v-card-title>
            <v-card-text>
                <v-overlay :value="loadingErrorLogsList">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-data-table
                    :items-per-page="10"
                    :footer-props="footerProps"
                    class="error-table"
                    :headers="errorTableHeaders"
                    :server-items-length="totalErrorLogs"
                    :items="errorLogs"
                    dense
                >
                    <template v-slot:item="{ item }">
                        <tr :key="'error_' + item.id">
                            <td>{{ getTypeUppercase(item.type) }}</td>
                            <td>{{ item.date ? item.date : "-" }}</td>
                            <td>{{ item.error ? item.error : "-" }}</td>
                            <td>{{ item.system_traceback ? item.system_traceback : "-" }}</td>
                            <td style="text-align: end">{{ item.data ? item.data : "-" }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-card elevation="2" class="mt-3">
            <v-card-title>{{ `Task ${t("Logs").toLowerCase()}` }}</v-card-title>
            <v-card-text>
                <v-overlay :value="loadingTaskLogsList">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-data-table
                    :items-per-page="10"
                    :footer-props="footerProps"
                    class="error-table"
                    :headers="taskTableHeaders"
                    :server-items-length="totalTaskLogs"
                    :items="taskLogs"
                    dense
                >
                    <template v-slot:item="{ item }">
                        <tr :key="'tast_' + item.id">
                            <td>{{ item.id }}</td>
                            <td>{{ item.task_name }}</td>
                            <td>{{ item.created_at ? item.created_at : "-" }}</td>
                            <td>{{ item.status ? item.status : "-" }}</td>
                            <td>{{ item.error ? item.error : "-" }}</td>
                            <td style="text-align: end">{{ item.data ? item.data : "-" }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "../../store";
export default {
    name: "logs-list",
    data() {
        return {
            footerProps: { "items-per-page-options": [10, 25, 50, 100] },
            cronTableHeaders: [
                {
                    text: this.t("Type"),
                    align: "left",
                    value: "type"
                },
                {
                    text: this.t("Date"),
                    align: "left",
                    value: "date"
                },
                {
                    text: this.t("New rows"),
                    align: "left",
                    value: "new_rows"
                },
                {
                    text: this.t("Rows edited"),
                    align: "left",
                    value: "rows_edited"
                },
                {
                    text: this.t("Error"),
                    align: "left",
                    value: "error"
                },
                {
                    text: this.t("File name"),
                    align: "left",
                    value: "file_name"
                },

                {
                    text: this.t("Status"),
                    align: "end",
                    value: "status"
                }
            ],
            errorTableHeaders: [
                {
                    text: this.t("Type"),
                    align: "left",
                    value: "type"
                },
                {
                    text: this.t("Date"),
                    align: "left",
                    value: "date"
                },
                {
                    text: this.t("Error"),
                    align: "left",
                    value: "error"
                },
                {
                    text: this.t("System error"),
                    align: "left",
                    value: "system_traceback"
                },
                {
                    text: this.t("Data"),
                    align: "end",
                    value: "data"
                }
            ],
            taskTableHeaders: [
                {
                    text: this.t("ID"),
                    align: "left",
                    value: "id"
                },
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "task_name"
                },
                {
                    text: this.t("Date"),
                    align: "left",
                    value: "created_at"
                },
                {
                    text: this.t("Status"),
                    align: "left",
                    value: "status"
                },
                {
                    text: this.t("Error"),
                    align: "left",
                    value: "error"
                },
                {
                    text: this.t("Data"),
                    align: "end",
                    value: "data"
                }
            ],
            options: this.tableOptions
        };
    },
    computed: {
        ...mapState("LogStore", [
            "cronLogs",
            "loadingCronLogsList",
            "totalCronLogs",
            "errorLogs",
            "taskLogs",
            "loadingErrorLogsList",
            "loadingTaskLogsList",
            "totalErrorLogs",
            "totalTaskLogs",
            "tableOptions"
        ])
    },
    async mounted() {
        //await Store.dispatch("LogStore/getCronLogs");
        await Store.dispatch("LogStore/getErrorLogs");
        await Store.dispatch("LogStore/getTaskLogs");
    },
    watch: {
        options(val) {
            Store.commit("LogStore/setTableOptions", val);
        }
    },
    methods: {
        getStatusColor(status) {
            if (status === "success") {
                return "#4CAF50";
            } else if (status === "failed") {
                return "#FF0000";
            } else {
                return "#FB8C00";
            }
        },
        getTypeUppercase(type) {
            if (type === "eugesta" || type === "smarten") {
                return type.charAt(0).toUpperCase() + type.slice(1);
            } else if (type === "sales_invoice") {
                return "Sales invoice";
            } else if (type === "product_import") {
                return "Product import";
            } else if (type === "eugesta_import") {
                return "Eugesta import from API";
            } else if (type === "cost_entries") {
                return "Cost entries";
            } else if (type === "odoo_own_price") {
                return "ODOO own price";
            } else if (type === "odoo_stocks") {
                return "ODOO stocks";
            } else {
                return type;
            }
        }
    }
};
</script>

<style scoped>
.cron-table,
.error-table {
    max-height: 400px;
    overflow: auto;
}
.dot {
    margin-top: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
td {
    height: 25px !important;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
</style>
